const cityToggleConfig = cityId => ({
  originalDocumentUploadCities: ['berlin', 'paris'].includes(cityId),
  isNoDepositSupported: ['milan', 'rome'].includes(cityId),
  isSuperListerSupported: true,
  showSelectInfoCard: false,
  hasRentalPriceIndex: ['barcelona'].includes(cityId)
});

export default cityToggleConfig;
